var map = {
	"./nb-video-resource.entry.js": [
		833,
		5
	],
	"./nb-video-simple_4.entry.js": [
		834,
		1
	],
	"./nb-videoplayer-download.entry.js": [
		835,
		4
	],
	"./nb-videoplayer.entry.js": [
		836,
		2
	],
	"./video-panel_2.entry.js": [
		837,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 765;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nobook/video-component/esm-es5 lazy ^\.\/.*\.entry\.js$
// module id = 765
// module chunks = 9